import { useCallback } from 'react';

export function useExport() {
  const exportToExcel = useCallback(async (
    data: Record<string, unknown>[],
    columns: { key: string; header: string }[],
    filename = 'export'
  ) => {
    try {
      const XLSX = await import('xlsx');
      const rows = data.map((row) =>
        columns.reduce((acc, col) => {
          acc[col.header] = row[col.key] as string;
          return acc;
        }, {} as Record<string, string>)
      );
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${filename}.xlsx`);
      console.log('Excel exported successfully');
    } catch {
      console.log('Failed to export Excel');
    }
  }, []);

  const exportToPdf = useCallback(async (elementRef: HTMLElement, filename = 'export') => {
    try {
      const html2canvas = (await import('html2canvas')).default;
      const { jsPDF } = await import('jspdf');
      const canvas = await html2canvas(elementRef, { scale: 2, backgroundColor: '#ffffff' });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${filename}.pdf`);
      console.log('PDF exported successfully');
    } catch {
      console.log('Failed to export PDF');
    }
  }, []);

  const printWidget = useCallback(() => {
    window.print();
  }, []);

  return { exportToExcel, exportToPdf, printWidget };
}
